import EN from './en-US';
import JP from './ja-JP';
import KO from './ko-KR';
import PT from './pt-PT';
import CN from './zh-CN';

enum Locale {
  CN = 'zh-CN',
  EN = 'en-US',
  JP = 'ja-JP',
  PT = 'pt-PT',
  KO_KR = 'ko-KR',
}

interface MessageDescriptor {
  id: string;
}

const LocaleStore: Record<string, Record<string, string>> = {
  [Locale.CN]: CN,
  [Locale.EN]: EN,
  [Locale.JP]: JP,
  [Locale.PT]: PT,
  [Locale.KO_KR]: KO,
};

const baseLocaleMessage = (localeStore: any, langParam: string) => {
  let lang = langParam;
  return (props: MessageDescriptor, context?: Record<string, any>) => {
    if (!localeStore[lang]) {
      if (localeStore[Locale.EN]) {
        lang = Locale.EN;
      } else {
        lang = Object.keys(localeStore)[0];
      }
    }
    // assign context
    let result = localeStore[lang][props.id] ?? props.id;
    if (context && Object.keys(context).length >= 0) {
      Object.keys(context).forEach((i) => {
        result = result.replace(`{${i}}`, context[i]);
      });
      return result;
    }
    return result;
  };
};

export const formatMessageWithLocale = (
  locale: string | undefined,
  descriptor: MessageDescriptor
) => {
  const lang = locale ?? Locale.EN;
  return baseLocaleMessage(LocaleStore, lang)(descriptor);
};
